import {Injectable, signal} from '@angular/core';

export interface Toastr {
	type?: 'SUCCESS' | 'DANGER' | 'WARNING' | 'INFO'
		// template?: TemplateRef<any>;
	title?:string;
	message?:string;
	// classname?: string;
	// delay?: number;
	timeoutMs?: number;
	disableTimeout?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  toasts = signal<Toastr[]>([]);

	private hasExistingToastr(toast:Toastr) {
		const existingToastr = this.toasts().find(i => (
			i.title === toast.title &&
			i.message === toast.message &&
			i.type === toast.type
		));

		return !!existingToastr
	}

	private addToastr(toast:Toastr){
		if (this.hasExistingToastr(toast)) return;

		this.toasts.update(prev => [...prev, toast]);
	}

	show(toast: Toastr | string) {
		if (typeof toast === 'string') {
			this.addToastr({ message: toast });

			return
		}

		this.addToastr(toast);
	}

	showDanger(message:string, title?:string) {
		this.addToastr({
			type: 'DANGER',
			message, title
		});
	}

	showSuccess(message:string, title?:string){
		this.addToastr({
			type: 'SUCCESS',
			message, title
		});
	}

	showInfo(message:string, title?:string){
		this.addToastr({
			type: 'INFO',
			message, title
		});
	}

	showWarning(message:string, title?:string){
		this.addToastr({
			type: 'WARNING',
			message, title
		});
	}

	remove(toast: Toastr) {
		this.toasts.update(prev => prev.filter((t) => t !== toast));
	}

	clear() {
		this.toasts.update(prev => prev.splice(0, prev.length));
	}
}
